import { render } from "./TheFooter.vue?vue&type=template&id=1e0435ec&scoped=true&ts=true"
import script from "./TheFooter.vue?vue&type=script&lang=ts"
export * from "./TheFooter.vue?vue&type=script&lang=ts"

import "./TheFooter.vue?vue&type=style&index=0&id=1e0435ec&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0435ec"]])

export default __exports__